__turbopack_context__.v({
  "btn": "button-module-scss-module___uMHJq__btn",
  "content": "button-module-scss-module___uMHJq__content",
  "contentHidden": "button-module-scss-module___uMHJq__contentHidden",
  "disabled": "button-module-scss-module___uMHJq__disabled",
  "error": "button-module-scss-module___uMHJq__error",
  "fitFull": "button-module-scss-module___uMHJq__fitFull",
  "fitInline": "button-module-scss-module___uMHJq__fitInline",
  "fitMdFull": "button-module-scss-module___uMHJq__fitMdFull",
  "fitMdInline": "button-module-scss-module___uMHJq__fitMdInline",
  "fitSmFull": "button-module-scss-module___uMHJq__fitSmFull",
  "fitSmInline": "button-module-scss-module___uMHJq__fitSmInline",
  "fitXlFull": "button-module-scss-module___uMHJq__fitXlFull",
  "fitXlInline": "button-module-scss-module___uMHJq__fitXlInline",
  "gradient": "button-module-scss-module___uMHJq__gradient",
  "iconOnly": "button-module-scss-module___uMHJq__iconOnly",
  "iconWrp": "button-module-scss-module___uMHJq__iconWrp",
  "onDark": "button-module-scss-module___uMHJq__onDark",
  "outline": "button-module-scss-module___uMHJq__outline",
  "primary": "button-module-scss-module___uMHJq__primary",
  "sizeL": "button-module-scss-module___uMHJq__sizeL",
  "sizeM": "button-module-scss-module___uMHJq__sizeM",
  "sizeS": "button-module-scss-module___uMHJq__sizeS",
  "solid": "button-module-scss-module___uMHJq__solid",
  "spinnerWrp": "button-module-scss-module___uMHJq__spinnerWrp",
  "success": "button-module-scss-module___uMHJq__success",
  "text": "button-module-scss-module___uMHJq__text",
});
